import React, { useRef } from 'react';
import { useNonMobileHover } from '@anton.bobrov/react-vevet-hooks';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import '../../../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../../../../common/GradientWrapper/index.js';
import { Icon } from '../../../../../../common/Icon/index.js';
import '../../../../../../common/LazyImage/index.js';
import '../../../../../../common/NumberFormat/index.js';
import '../../../../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const SimpleLink = ({
  className,
  style,
  name,
  icon,
  additional,
  disableHover,
  background,
  isActive = false,
  isIconRounded,
  isSubItem,
  href,
  ...props
}) => {
  const ref = useRef(null);
  const isHovered = useNonMobileHover(ref);
  return /* @__PURE__ */ React.createElement(
    Link,
    {
      ...props,
      to: href,
      ref,
      className: cx(styles.box, className, {
        [styles["disable-hover"]]: disableHover || isActive,
        [styles.active]: isActive,
        [styles.hovered]: isHovered,
        [styles["sub-item"]]: isSubItem
      }),
      style: {
        ...style,
        background,
        "--text-color": "#fff",
        "--hover-color": "#fff"
      },
      "aria-current": isActive && "page",
      "data-active": isActive,
      "data-styled-link": true
    },
    icon && /* @__PURE__ */ React.createElement("span", { className: styles["icon-container"], "data-rounded": isIconRounded }, /* @__PURE__ */ React.createElement(Icon, { customIcon: icon })),
    /* @__PURE__ */ React.createElement("span", { className: styles.text }, name),
    additional && !additional?.node && /* @__PURE__ */ React.createElement(
      "span",
      {
        className: styles["add-text"],
        style: {
          "--add-bg": additional.backgroundColor || "#FF961C29",
          "--add-text-color": additional.color || "#FF961C"
        }
      },
      additional.icon && additional.iconLeft && /* @__PURE__ */ React.createElement("span", { className: styles["icon-container"] }, /* @__PURE__ */ React.createElement(Icon, { customIcon: additional.icon })),
      additional.text,
      additional.icon && !additional.iconLeft && /* @__PURE__ */ React.createElement("span", { className: styles["icon-container"] }, /* @__PURE__ */ React.createElement(Icon, { customIcon: additional.icon }))
    ),
    additional && additional.node && /* @__PURE__ */ React.createElement("span", { className: styles["add-node"] }, additional.node)
  );
};

export { SimpleLink };
//# sourceMappingURL=index.js.map
